import Dashboard from './components/modules/dashboard/Dashboard'
import ContentPages from './components/modules/page-content/index'
import ClientPages from './components/modules/client/index'
import PeoplePages from './components/modules/people/index'
import FinancePages from './components/modules/finance/index'
import AnalyticsPages from './components/modules/analytics/index'
import AccountPages from './components/modules/account/index'
import AdministrationPages from './components/modules/administration/index'

export const ROLES = {
    User: 'user',
    Editor: 'editor',
    Admin: 'admin',
    Owner: 'owner',
}

const routesConfig = [
    {
        path: '/',
        breadcrumb: 'Dashboard',
        component: Dashboard,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
        pageLayout: false,
        icon: 'fa-solid fa-gauge-high',
    },
    {
        path: '/account',
        component: AccountPages.AccountMyAccount,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/account/activity-log',
        component: AccountPages.AccountActivityLog,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/administration',
        component: AdministrationPages.AdministrationHome,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/emails',
        component: AdministrationPages.SettingsEmails,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/emails/view',
        static: true,
    },
    {
        path: '/administration/emails/view/:emailTemplateId',
        component: AdministrationPages.EmailTemplatesView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/main-contacts',
        component: AdministrationPages.MainContactsView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/languages',
        component: AdministrationPages.Languages,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/languages/view',
        static: true,
    },
    {
        path: '/administration/languages/new',
        component: AdministrationPages.LanguagesCreate,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/languages/view/:languageId',
        component: AdministrationPages.LanguagesView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/translations',
        component: AdministrationPages.Translations,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/translations/view',
        static: true,
    },
    {
        path: '/administration/translations/view/:translationId',
        component: AdministrationPages.TranslationsView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/date-and-time',
        component: AdministrationPages.DateAndTime,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/social-media-links',
        component: AdministrationPages.SocialMediaLinksView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/currencies',
        component: AdministrationPages.Currencies,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/currencies/view',
        static: true,
    },
    {
        path: '/administration/currencies/new',
        component: AdministrationPages.CurrenciesCreate,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/currencies/view/:currencyId',
        component: AdministrationPages.CurrenciesView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/api-manager',
        component: AdministrationPages.APIManager,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/users',
        component: AdministrationPages.Users,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/users/view',
        static: true,
    },
    {
        path: '/administration/users/new',
        component: AdministrationPages.UsersCreate,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/users/view/:userId',
        component: AdministrationPages.UsersView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/website-builder',
        component: AdministrationPages.WebsiteBuilder,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/content',
        static: true,
    },
    {
        path: '/content/pages',
        component: ContentPages.Pages,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/pages/view',
        static: true,
    },
    {
        path: '/content/pages/new',
        component: ContentPages.PagesCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/pages/view/:pageId',
        component: ContentPages.PagesView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/page-sections',
        component: ContentPages.PageSections,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/page-sections/view',
        static: true,
    },
    {
        path: '/content/page-sections/view/:pageSectionId',
        component: ContentPages.PageSectionsView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/page-sections/new',
        component: ContentPages.PageSectionsCreate,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/content/page-layout',
        component: ContentPages.PageLayout,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/content/page-builder',
        component: ContentPages.PageBuilder,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
        breadcrumb: 'Page Builder',
    },
    {
        path: '/content/page-builder/:pageId',
        component: ContentPages.PageBuilder,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
        breadcrumb: 'Page Builder',
    },

    {
        path: '/client',
        static: true,
    },
    {
        path: '/client/modules',
        static: true,
    },
    {
        path: '/client/modules/:module',
        component: ClientPages.ModuleRecords,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/client/modules/:module/view',
        static: true,
    },
    {
        path: '/client/modules/:module/new',
        component: ClientPages.ModuleRecordsCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/client/modules/:module/view/:recordId',
        component: ClientPages.ModuleRecordsView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },

    {
        path: '/people',
        static: true,
    },
    {
        path: '/people/team',
        static: true,
    },

    {
        path: '/people/team/members',
        component: PeoplePages.TeamMembers,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/team/members/view',
        static: true,
    },
    {
        path: '/people/team/members/new',
        component: PeoplePages.TeamMembersCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/team/members/view/:teamMemberId',
        component: PeoplePages.TeamMembersView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },

    {
        path: '/people/team/departments',
        component: PeoplePages.TeamDepartments,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/team/departments/view',
        static: true,
    },
    {
        path: '/people/team/departments/view/:departmentId',
        component: PeoplePages.TeamDepartmentsView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/team/departments/new',
        component: PeoplePages.TeamDepartmentsCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },

    {
        path: '/people/clients',
        static: true,
    },
    {
        path: '/people/clients/subscription-requests',
        component: PeoplePages.SubscriptionRequests,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/clients/subscription-requests/view',
        static: true,
    },
    {
        path: '/people/clients/subscription-requests/view/:subscriptionId',
        component: PeoplePages.SubscriptionView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/clients/email-campaigns',
        component: PeoplePages.NewsletterClients,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/clients/email-campaigns/view',
        static: true,
    },
    {
        path: '/people/clients/email-campaigns/new',
        component: PeoplePages.NewsletterCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/people/clients/email-campaigns/view/:newsletterId',
        component: PeoplePages.NewsletterView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/finance',
        static: true,
    },
    {
        path: '/finance/payments',
        component: FinancePages.FinancePayments,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/finance/payments/view',
        static: true,
    },
    {
        path: '/finance/payments/view/:paymentId',
        component: FinancePages.FinancePaymentsView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/finance/payments/new',
        component: FinancePages.FinancePaymentsCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/analytics',
        static: true,
    },
    {
        path: '/analytics/google',
        static: true,
    },

    {
        path: '/analytics/google/categories',
        component: AnalyticsPages.AnalyticsGoogleCategories,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/analytics/google/categories/view',
        static: true,
    },

    {
        path: '/analytics/google/actions',
        component: AnalyticsPages.AnalyticsGoogleActions,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/analytics/google/actions/view',
        static: true,
    },

    {
        path: '/administration/navigation',
        component: AdministrationPages.Navigation,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/navigation/view',
        static: true,
    },
    {
        path: '/administration/navigation/new',
        component: AdministrationPages.NavigationCreate,
        roles: [ROLES.Admin],
        protected: true,
    },
    {
        path: '/administration/navigation/view/:navigationId',
        component: AdministrationPages.NavigationView,
        roles: [ROLES.Admin],
        protected: true,
    },

    {
        path: '/administration/client',
        static: true,
    },
    {
        path: '/administration/client/identity',
        component: AdministrationPages.ClientIdentities,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/administration/client/identity/view',
        static: true,
    },
    {
        path: '/administration/client/identity/view/:clientIdentityId',
        component: AdministrationPages.ClientIdentityView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/administration/client/identity/new',
        component: AdministrationPages.ClientIdentityCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },

    {
        path: '/administration/client/theme',
        component: AdministrationPages.ClientThemes,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/administration/client/theme/view',
        static: true,
    },
    {
        path: '/administration/client/theme/view/:clientThemeId',
        component: AdministrationPages.ClientThemeView,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
    {
        path: '/administration/client/theme/new',
        component: AdministrationPages.ClientThemeCreate,
        roles: [ROLES.Admin, ROLES.Editor, ROLES.User],
        protected: true,
    },
]

export default routesConfig
